import { Component, ElementRef, Inject } from '@angular/core';
import { EventBus, EventBusBase, RoutingService } from '@skylab-angular-shared/core';
import { MenuComponentBase } from '../menu-base.component';
import { MenuItemSubComponent } from '../menu-item-sub/menu-item-sub.component';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
    selector: 'skl-menu-pointer',
    templateUrl: './menu-pointer.component.html',
    imports: [MenuItemSubComponent, MenuItemComponent]
})
export class MenuPointerComponent extends MenuComponentBase {
    public constructor(
        elRef: ElementRef,
        routingService: RoutingService,
        @Inject(EventBus) eventBus: EventBusBase) {
        super(elRef, eventBus, routingService);
    }
}
